export default "__VITE_ASSET__DnjUBm2g__"